export default {
    versionHistory: [],
    isVersionHistoryLoaded: false,
    versionHistoryItem: {},
    isVersionHistoryItemLoaded: false,
    isVersionHistoryItemSaving: false,
    latestVersionHistorySavedItem: {},
    // This client's save awaiting the integration's reply, and the item it replaced.
    pendingVersionHistorySave: null,
    // versionIDs of items whose save was rejected, so a slower refetch cannot bring one back.
    // An id is dropped again only when that same version is saved successfully.
    rejectedVersionIDs: [],
};
